import { cornType } from '@eigtech/shared-corn';
export const serviceName = 'white-label';
export const whiteLabelServiceCorn = (resourceType) => cornType(serviceName, resourceType);
